import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { setupListeners } from "@reduxjs/toolkit/query";

import { usersApi } from "../services/userApi";
import { userLogApi } from "../services/userLogApi";
import { datasApi } from "../services/dataApi";
import { datasheetApi } from "../services/datasheetApi";
import { worksheetApi } from "../services/worksheetApi";
import { worksheet1Api } from "../services/worksheet1Api";
import { worksheet2Api } from "../services/worksheet2Api";
import { worksheet3Api } from "../services/worksheet3Api";
import { worksheet4Api } from "../services/worksheet4Api";
import { worksheet5Api } from "../services/worksheet5Api";

import { authSlice } from "../services/authSlice";
import { logicSlice } from "../services/agen";
import {
	MiddlewareAPI,
	isRejectedWithValue,
	Middleware,
} from "@reduxjs/toolkit";
import notification from "../../components/Notification";

export const rtkQueryErrorLogger: Middleware =
	(api: MiddlewareAPI) => (next) => (action) => {
		if (isRejectedWithValue(action)) {
			switch (action.payload.originalStatus) {
				case 500: {
					notification.error({
						title: "Server Error",
						message: action.payload.data,
					});
					break;
				}
				case 400: {
					notification.error({
						title: "Error",
						message: action.payload.data,
					});
					break;
				}
				case 300: {
					notification.error({
						title: "Error",
						message: action.payload.data,
					});
					break;
				}
				case 200: {
					notification.success({
						title: "Sucess",
						message: action.payload.data,
					});
					break;
				}
			}
		}

		return next(action);
	};

const rootReducer = combineReducers({
	[usersApi.reducerPath]: usersApi.reducer,
	[userLogApi.reducerPath]: userLogApi.reducer,
	[datasApi.reducerPath]: datasApi.reducer,
	[datasheetApi.reducerPath]: datasheetApi.reducer,
	[worksheetApi.reducerPath]: worksheetApi.reducer,
	[worksheet1Api.reducerPath]: worksheet1Api.reducer,
	[worksheet2Api.reducerPath]: worksheet2Api.reducer,
	[worksheet3Api.reducerPath]: worksheet3Api.reducer,
	[worksheet4Api.reducerPath]: worksheet4Api.reducer,
	[worksheet5Api.reducerPath]: worksheet5Api.reducer,

	gdata: authSlice.reducer,
	glogic: logicSlice.reducer,
});

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddiware) =>
		getDefaultMiddiware().concat(
			rtkQueryErrorLogger,
			usersApi.middleware,
			userLogApi.middleware,
			datasApi.middleware,
			datasheetApi.middleware,
			worksheetApi.middleware,
			worksheet1Api.middleware,
			worksheet2Api.middleware,
			worksheet3Api.middleware,
			worksheet4Api.middleware,
			worksheet5Api.middleware
		),
	devTools: true,
});

export default store;
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
